import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Language detection and fallback logic
const supportedLanguages = ['en', 'ar'];
const browserLanguage = navigator.language.split('-')[0];
const savedLanguage = supportedLanguages.includes(localStorage.getItem('i18nextLng'))
  ? localStorage.getItem('i18nextLng')
  : supportedLanguages.includes(browserLanguage)
    ? browserLanguage
    : 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: savedLanguage, // Use the determined language
    supportedLngs: supportedLanguages, // Add supported languages
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    resources: {
      en: {
        translation: require('./locales/en.json')
      },
      ar: {
        translation: require('./locales/ar.json')
      }
    }
  });

// Set initial direction and lang attribute
document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLanguage;

export default i18n;
